import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const [jobTitle, setJobTitle] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');  // For handling any error messages
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  // Handle form submission and send data to backend
  const handlePosting = async (e) => {
    e.preventDefault();

    // Make sure the form has both jobTitle and description
    if (!jobTitle || !description) {
      setError('Please fill in both fields');
      return;
    }

    setError(''); // Clear any previous errors

    const jobDetails = {
      jobTitle,
      description
    };

    try {
      const response = await fetch('https://apis.anvifoundation.com/anvi/post-job', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(jobDetails),
      });

      if (!response.ok) {
        throw new Error('Failed to post job');
      }

      // Clear the form on success
      setJobTitle('');
      setDescription('');
      // alert('Job posted successfully!');
      window.location.reload();
    } catch (error) {
      setError('Something went wrong. Please try again.');
      console.error(error);
    }
  };


  const fetchJobs = async () => {
    try {
      const response = await fetch('https://apis.anvifoundation.com/anvi/get-job');
      console.log(response);
      if (!response.ok) {
        throw new Error('Failed to fetch jobs');
      }
      const data = await response.json();
      setJobs(data.jobs);
    } catch (error) {
      setError('Failed to load jobs');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };


  // Handle delete job
  const handleDeleteJob = async (id) => {
    try {
      const response = await fetch(`https://apis.anvifoundation.com/anvi/delete-job/${id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Failed to delete job');
      }

      // Remove the deleted job from the state
      setJobs((prevJobs) => prevJobs.filter(job => job.id !== id));
      // alert('Job deleted successfully');
    } catch (error) {
      setError('Failed to delete job');
      console.error(error);
    }
  };

  // Fetch jobs on component mount
  useEffect(() => {
    fetchJobs();
  }, []);



  return (
    <>
      <section className='my-5'>
        <div className='container'>

          <div className='row'>

            <div className='col-lg-8 col-12 my-2'>
              <div className='job-card-area'>
                <p className='sec-heading'>Jobs Openings</p>
                <hr className='sec-heading-hr my-auto' />

                {/* Loading indicator */}
                {loading ? (
                  <p>Loading jobs...</p>
                ) : (
                  jobs.map((job, index) => (
                    <div key={index} className='job-card mt-4'>
                      <p className='sec-heading5'>Position: {job.jobTitle}</p>
                      <p className='text-muted'>Job Description<br />{job.description}</p>
                      <p className='text-muted'>Posted on: {new Date(job.datePosted).toLocaleDateString()}</p>
                      <button className='donate-btn' onClick={() => handleDeleteJob(job.id)}>Delete this Job &nbsp;<i class="fa-regular fa-trash-can"></i></button>
                      {/* flex ends */}

                    </div>
                  ))
                )}

              </div>
            </div>
            {/* job left area */}

            <div className='col-lg-4 col-12 my-2'>
              <div className='bg-light px-4 py-4'>
                <p className='sec-heading5'>Post A New Job</p>
                <hr />

                <form class="row g-3 my-4" onSubmit={handlePosting}>
                  <div class="col-12">
                    <input type="text" class="form-text" id="inputText4" value={jobTitle} onChange={(e) => setJobTitle(e.target.value)} placeholder='Job Title' />
                  </div>
                  <div class="col-12">
                    <input type="description" class="form-text" id="inputPassword4" value={description} onChange={(e) => setDescription(e.target.value)} placeholder='Description' style={{ height: '8em' }} />
                  </div>
                  {error && <div className="col-12 text-danger">{error}</div>}
                  <div class="col-12">
                    <button type="submit" class="donate-btn w-100">Submit</button>
                  </div>
                </form>
              </div>

              <div className='bg-light px-4 py-4 my-3'>
                <p className='sec-heading5'>Important</p>
                <hr />
                <button class="donate-btn" onClick={() => navigate('/admin/job-application')}>Job Applications</button><br />

                <button class="donate-btn my-2" onClick={() => navigate('/admin/admin-gallery')}>My Image Gallery</button>
              </div>

            </div>
            {/* posting form ends */}


          </div>
          {/* row ends */}

        </div>
      </section>
    </>
  )
}

export default Dashboard
